import { render, staticRenderFns } from "./optionSensitiveWordTypeDialog1.vue?vue&type=template&id=480eb783&scoped=true&"
import script from "./optionSensitiveWordTypeDialog1.vue?vue&type=script&lang=js&"
export * from "./optionSensitiveWordTypeDialog1.vue?vue&type=script&lang=js&"
import style0 from "./optionSensitiveWordTypeDialog1.vue?vue&type=style&index=0&id=480eb783&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480eb783",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480eb783')) {
      api.createRecord('480eb783', component.options)
    } else {
      api.reload('480eb783', component.options)
    }
    module.hot.accept("./optionSensitiveWordTypeDialog1.vue?vue&type=template&id=480eb783&scoped=true&", function () {
      api.rerender('480eb783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/KeyWordSettings/optionSensitiveWordTypeDialog1.vue"
export default component.exports